export default __webpack_public_path__ + "4fdc869c97b4d700ae632bb82036314e.svg";